import React from 'react';
import MutedText from "@manual_encounters/encounter_reconcile/pings/common/MutedText";

const UNAVAILABLE = 'Unavailable';

const InformationUnavailable = ({ skipFormatting = false, onClick }) => {
  if (skipFormatting) {
    return <span onClick={onClick}>{UNAVAILABLE}</span>;
  }

  return <MutedText onClick={onClick}>{UNAVAILABLE}</MutedText>;
};

export default InformationUnavailable;
